<template>
    <div class="defbutInfo">
        <div class="tips flex-row">
            <p>产品</p>
            <p>小计</p>
        </div>
        <div class="commodity flex-row" v-for="(el, index) in orderList" :key="index">
            <p>吊柜：{{el.commodityName}}</p>
            <p>{{el.amount}} * {{el.onePrice}} = {{el.amount * el.onePrice}}</p>
        </div>
        <div class="sum flex-row">
            <p>合计：</p>
            <p class="number">{{sum}}</p>
        </div>
    </div>
</template>
<script>
import { listOrderBudgetDetail } from '@/api/index';
export default {
    data(){
        return {
            sum:0
        }
    },
    created(){
        this.getData()
    },
    methods:{
        getData(){
            listOrderBudgetDetail({budgetId: 1}).then(res => {
                this.orderList = res.data;
                this.sum = 0;
                res.data.forEach(el => {
                    this.sum += el.amount * el.onePrice;
                });
            }).catch(error => {
                console.log('获取预算清单列表 views/budget/index.vue');
            })
        },    
    }
}
</script>
<style lang="scss" scoped>
.defbutInfo{
    .tips{
        border: 1px solid #e3e3e3;
        background: RGBA(246, 246, 246, 1);
        p{
            width: 50vw;
            text-align: center;
            font-size:30px; 
            height: 70px;
            line-height: 70px;
        }
    }
    .commodity{
         border-bottom: 1px solid #e3e3e3;
        p{
            width: 50vw;
            text-align: center;
            font-size:30px; 
            height: 80px;
            line-height: 80px;
        }
    }
    .sum{
        p{
            width: 50vw;
            text-align: center;
            height: 70px;
            line-height: 70px;
        }
        .number{
            font-size: 40px;
            color: red;
        }
    }
}
</style>

